<div *ngIf="media == null" class="avatarIcon" [style.fontSize]="fontSize" [style.width.px]="size"
     [style.padding-left]="padLeft" [style.padding-top]="padTop" [style.height.px]="size">{{initials}}
</div>
<div *ngIf="media != null">
  <img [src]="media | safe: 'resourceUrl'" alt="Profile Image" [style.width.px]="size" [style.height.px]="size" class="avatarIcon">
</div>
